/**
 * user - auth
 *
 * @author Shigq
 * @date 2021/6/21 10:46
 */
import { t, fileComp } from '../base'

// 收款列表
const CollectionReq = [
  { prop: 'acctName', label: t('collection.form.text_1'), placeholder: t('client.placeholder.text_1'), default: '' },
  { prop: 'inviteCode', label: t('dashboard.table.text_7'), placeholder: t('client.placeholder.inviteCode'), default: '' },
  { prop: 'transinCur', label: t('collection.form.text_2'), default: '' },
  { prop: 'sysTxnDate', label: t('collection.form.text_3'), default: [] },
  { prop: 'noticeStatList', label: t('trade.table.text_12'), placeholder: t('client.placeholder.text_3'), default: [] },
]

// 交易列表
const PaymentReq = [
  { prop: 'acctName', label: t('trade.form.text_1'), placeholder: t('client.placeholder.text_1'), default: '' },
  { prop: 'inviteCode', label: t('dashboard.table.text_7'), placeholder: t('client.placeholder.inviteCode'), default: '' },
  { prop: 'buyCur', label: '买入币种', default: '' },
  { prop: 'sellCur', label: t('trade.form.text_4'), default: '' },
  { prop: 'txnStatusList', label: t('trade.table.text_12'), placeholder: t('client.placeholder.text_3'), default: '' },
  { prop: 'sysTxnDate', label: t('trade.form.text_2'), default: [] },
  { prop: 'completeDate', label: t('trade.form.text_3'), default: [] }
]

// 客户列表
const ClientReq = [
  { prop: 'acctName', label: t('client.form.text_1'), placeholder: t('client.placeholder.text_1'), default: '' },
  { prop: 'acctId', label: t('client.form.text_2'), placeholder: t('client.placeholder.text_2'), default: '' },
  { prop: 'inviteCode', label: t('dashboard.table.text_7'), placeholder: t('client.placeholder.inviteCode'), default: '' },
  { prop: 'acctStat', label: t('client.form.text_3'), placeholder: t('client.placeholder.text_3'), default: '' },
  { prop: 'regDate', label: t('client.form.text_4'), placeholder: t('client.placeholder.text_4'), default: [] },
  { prop: 'incomeDate', label: t('client.form.text_5'), placeholder: t('client.placeholder.text_5'), default: [] },
]
// 未开户客户列表
const NoUseClientReq = [
  { prop: 'acctId', label: t('client.form.text_2'), placeholder: t('client.placeholder.text_2'), default: '' },
  { prop: 'inviteCode', label: t('client.form.text_6'), placeholder: t('client.placeholder.inviteCode'), default: '' },
  { prop: 'registerType', label: t('client.registerType.label'), placeholder: t('client.placeholder.text_3'), default: '' },
  { prop: 'stepComplete', label: t('client.stepComplete.label'), placeholder: t('client.placeholder.text_3'), default: '' },
  { prop: 'registerDate', label: t('client.form.text_7'), placeholder: t('client.placeholder.text_4'), default: [] },
  { prop: 'submitDate', label: t('client.form.submitDate'), placeholder: t('client.placeholder.text_4'), default: [] },
]

// 销售结算列表
const SalesSettlementReq = [
  { prop: 'monthId', label: t('salesSettlement.form.month'), placeholder: t('salesSettlement.placeholder.month'), default: '' },
  { prop: 'inviteCode', label: t('dashboard.table.text_7'), placeholder: t('client.placeholder.inviteCode'), default: '' },
]

export {
  CollectionReq,
  PaymentReq,
  ClientReq,
  NoUseClientReq,
  SalesSettlementReq
}
